module.exports = __webpack_public_path__ + "assets/images/default-userpic-50-e631afb0dd91ea6c429af086461a8a41.png";